import EmojiData from '@web-lite/emoji-mart-data/sets/14/apple.json'
import { init } from '@web-lite/emoji-mart'
import { t } from '$i18n'

export const emojiI18n = t('emojiPicker', { returnObjects: true })

init({ data: EmojiData, set: 'apple', i18n: emojiI18n })

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace React.JSX {
    interface IntrinsicElements {
      'em-emoji': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & { set?: string; spritesheeturl?: string }
    }
  }
}
